import React from 'react'

// Іконка закриття (Close)
export const CloseIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
  >
    <rect
      x="0.671875"
      y="0.666626"
      width="26.6667"
      height="26.6667"
      rx="8"
      stroke="#BFBFBF"
      strokeWidth="1.25"
    />
    <path
      d="M11.1713 16.8287L16.8281 11.1719"
      stroke="#BFBFBF"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.1713 11.1719L16.8281 16.8287"
      stroke="#BFBFBF"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

// Іконка прапора України для коду країни
export const UkraineFlagIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg
    className={className}
    width="19"
    height="17"
    viewBox="0 0 19 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Group">
      <path
        d="M8.13802e-05 15.0197C8.13802e-05 16.0903 0.867899 16.9582 1.93848 16.9582H16.395C17.4655 16.9582 18.3334 16.0904 18.3334 15.0197V8.47917H8.13802e-05V15.0197Z"
        fill="#FFE15A"
        id="Vector"
      />
      <path
        d="M16.3949 0H1.9384C0.867817 0 0 0.867852 0 1.93847V8.47904H18.3333V1.93847C18.3333 0.867852 17.4655 0 16.3949 0Z"
        fill="#4173CD"
        id="Vector_2"
      />
    </g>
  </svg>
)

// Іконка стрілки вниз для вибору коду країни
export const DownArrowIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    width="12"
    height="6"
    viewBox="0 0 12 6"
    fill="none"
  >
    <path
      d="M1.33594 0.999999L5.48197 4.55374C5.78156 4.81054 6.22365 4.81054 6.52324 4.55374L10.6693 1"
      stroke="#A3A3A3"
      strokeLinecap="round"
    />
  </svg>
)

// Іконка стрілки вправо для кнопки "Вхід"
export const RightArrowIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    width="16"
    height="15"
    viewBox="0 0 16 15"
    fill="none"
  >
    <path
      d="M8.17188 0.168701V0.168701C8.17188 4.03153 11.3088 7.16778 15.1716 7.15742V7.15742"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      d="M8.17188 14.1659V14.1659C8.17187 10.3031 11.3088 7.16681 15.1716 7.17717V7.17717"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path d="M12.8359 7.16589L0.835938 7.16589" stroke="currentColor" strokeWidth="1.5" />
  </svg>
)

// Іконка пошти для кнопки "Продовжити з email"
export const MailIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    width="16"
    height="12"
    viewBox="0 0 16 12"
    fill="none"
  >
    <path
      d="M11.3359 0.166992C13.453 0.166992 15.1699 1.88291 15.1699 4V8C15.1699 10.1171 13.453 11.833 11.3359 11.833H4.66992C2.55283 11.833 0.835938 10.1171 0.835938 8V4C0.835938 1.88291 2.55283 0.166992 4.66992 0.166992H11.3359ZM12.6025 3.5498C12.3539 3.2187 11.884 3.15194 11.5527 3.40039L8.75293 5.5C8.30849 5.83333 7.69737 5.83333 7.25293 5.5L4.45312 3.40039C4.12186 3.15194 3.65191 3.2187 3.40332 3.5498C3.15487 3.88107 3.22163 4.35102 3.55273 4.59961L6.35254 6.7002C7.33032 7.43353 8.67554 7.43353 9.65332 6.7002L12.4531 4.59961C12.7842 4.35102 12.851 3.88107 12.6025 3.5498Z"
      fill="#0D0D0D"
    />
  </svg>
)

export const PhoneIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg
    width="17"
    className={className}
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.208 13.4789C11.9052 14.7817 8.56855 13.5575 5.75551 10.7445C2.94248 7.93145 1.71826 4.59485 3.02114 3.29197L3.87898 2.43412C4.4712 1.8419 5.44703 1.85756 6.05856 2.46909L7.38728 3.79781C7.99881 4.40934 8.01447 5.38517 7.42225 5.97739L7.23799 6.16165C6.91825 6.48139 6.88696 6.99721 7.18407 7.35725C7.47064 7.70452 7.7796 8.05043 8.11458 8.38542C8.44957 8.7204 8.79548 9.02936 9.14275 9.31593C9.50279 9.61304 10.0186 9.58175 10.3384 9.26201L10.5226 9.07775C11.1148 8.48553 12.0907 8.50119 12.7022 9.11272L14.0309 10.4414C14.6424 11.053 14.6581 12.0288 14.0659 12.621L13.208 13.4789Z"
      fill="#0D0D0D"
      stroke="#0D0D0D"
      strokeWidth="1.5"
    />
  </svg>
)

// Ілюстрація з логотипом Seaters (стілець з чашкою)
export const SeatersIllustration: React.FC<{ className?: string }> = ({ className }) => (
  <svg
    className={className}
    width="264"
    height="327"
    viewBox="0 0 264 327"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M48.0673 190.634C48.1466 190.141 48.5717 189.779 49.0706 189.779H55.4895C55.9624 189.779 56.3727 190.105 56.4795 190.566L87.4402 324.213C87.5469 324.674 87.9573 325 88.4302 325H107.497C108.148 325 108.631 324.396 108.488 323.761L79.7946 196.176C79.6564 195.561 80.1047 194.97 80.7337 194.938L179.567 189.843C180.211 189.81 180.723 190.377 180.624 191.014L167.638 274.788C167.56 275.289 167.864 275.771 168.35 275.917L176.963 278.501C177.503 278.663 178.072 278.354 178.23 277.812L204.535 187.585C204.628 187.266 204.871 187.012 205.186 186.906L211.069 184.92C211.642 184.727 212.255 185.072 212.386 185.662L238.068 300.972C238.171 301.437 238.584 301.767 239.06 301.767H260.769C261.407 301.767 261.888 301.185 261.766 300.558L236.864 171.682C236.761 171.146 237.099 170.625 237.63 170.5L252.681 166.972C253.103 166.874 253.415 166.518 253.46 166.087L255.894 142.476C255.951 141.926 255.557 141.432 255.008 141.364L231.408 138.444C230.971 138.39 230.618 138.061 230.535 137.628L219.39 79.8808C219.281 79.3115 219.669 78.7658 220.242 78.6826L252.416 74.0162C252.957 73.9377 253.339 73.4453 253.281 72.9017L251.643 57.6954C251.593 57.2323 251.235 56.8624 250.774 56.7979L171.754 45.738C171.259 45.6688 170.888 45.2508 170.879 44.7517L170.054 2.8553C170.043 2.28955 169.571 1.84188 169.006 1.85962L4.7284 7.01183C4.11341 7.03112 3.65652 7.5882 3.75797 8.19506L11.8227 56.4374L3.01491 56.8226C2.45434 56.8471 2.01973 57.3213 2.04408 57.8819L3.51755 91.8102C3.54364 92.4107 4.0825 92.8575 4.6775 92.7719L16.9282 91.0092L20.9124 116.044C20.9942 116.558 21.4505 116.927 21.9698 116.899L34.7303 116.223L30.343 140.649C30.2561 141.134 29.8348 141.486 29.3428 141.486H21.8949C21.408 141.486 20.9895 141.831 20.8972 142.309L16.815 163.441C16.7071 163.999 17.0788 164.538 17.6394 164.635L29.2603 166.646C29.7857 166.737 30.1514 167.218 30.0981 167.749L16.7309 300.649C16.6707 301.248 17.1406 301.767 17.742 301.767H29.327C29.8259 301.767 30.251 301.405 30.3303 300.912L48.0673 190.634ZM66.7993 114.524L173.404 108.907C173.953 108.878 174.379 108.418 174.366 107.869L173.79 83.4722C173.777 82.9245 174.201 82.4651 174.748 82.4337L195 81.2698C195.712 81.2288 196.244 81.9154 196.026 82.5947L181.024 129.349C180.898 129.743 180.546 130.021 180.134 130.052L72.5914 138.285C72.0812 138.324 71.6216 137.978 71.5185 137.477L66.7993 114.524Z"
      fill="#0D0D0D"
    />
    <path
      d="M34.7303 116.223L30.343 140.649C30.2561 141.134 29.8348 141.486 29.3428 141.486H21.8949C21.408 141.486 20.9895 141.831 20.8972 142.309L16.815 163.441C16.7071 163.999 17.0788 164.538 17.6394 164.635L29.2603 166.646C29.7857 166.737 30.1514 167.218 30.0981 167.749L16.7309 300.649C16.6707 301.248 17.1406 301.767 17.742 301.767H29.327C29.8259 301.767 30.251 301.405 30.3303 300.912L48.0673 190.634C48.1466 190.141 48.5717 189.779 49.0706 189.779H55.4895C55.9624 189.779 56.3727 190.105 56.4795 190.566L87.4402 324.213C87.5469 324.674 87.9573 325 88.4302 325H107.497C108.148 325 108.631 324.396 108.488 323.761L79.7946 196.176C79.6564 195.561 80.1047 194.97 80.7337 194.938L179.567 189.843C180.211 189.81 180.723 190.377 180.624 191.014L167.638 274.788C167.56 275.289 167.864 275.771 168.35 275.917L176.963 278.501C177.503 278.663 178.072 278.354 178.23 277.812L204.535 187.585C204.628 187.266 204.871 187.012 205.186 186.906L211.069 184.92C211.642 184.727 212.255 185.072 212.386 185.662L238.068 300.972C238.171 301.437 238.584 301.767 239.06 301.767H260.769C261.407 301.767 261.888 301.185 261.766 300.558L236.864 171.682C236.761 171.146 237.099 170.625 237.63 170.5L252.681 166.972C253.103 166.874 253.415 166.518 253.46 166.087L255.894 142.476C255.951 141.926 255.557 141.432 255.008 141.364L231.408 138.444C230.971 138.39 230.618 138.061 230.535 137.628L219.39 79.8808C219.281 79.3115 219.669 78.7658 220.242 78.6826L252.416 74.0162C252.957 73.9377 253.339 73.4453 253.281 72.9017L251.643 57.6954C251.593 57.2323 251.235 56.8624 250.774 56.7979L171.754 45.738C171.259 45.6688 170.888 45.2508 170.879 44.7517L170.054 2.8553C170.043 2.28955 169.571 1.84188 169.006 1.85962L4.7284 7.01183C4.11341 7.03112 3.65652 7.5882 3.75797 8.19506L11.8227 56.4374M34.7303 116.223L21.9698 116.899C21.4505 116.927 20.9942 116.558 20.9124 116.044L16.9282 91.0092M34.7303 116.223L39.6025 89.0969C39.725 88.4147 39.1436 87.8128 38.4576 87.9115L16.9282 91.0092M16.9282 91.0092L4.6775 92.7719C4.0825 92.8575 3.54364 92.4107 3.51755 91.8102L2.04408 57.8819C2.01973 57.3213 2.45434 56.8471 3.01491 56.8226L11.8227 56.4374M11.8227 56.4374L94.1653 62.3751C94.6188 62.4078 94.9953 62.7376 95.0874 63.1828L98.0958 77.7261C98.2183 78.3183 97.7997 78.8858 97.1977 78.9435L79.2691 80.6627L61.3391 82.382C60.7376 82.4397 60.319 83.0064 60.4407 83.5982L66.7993 114.524M66.7993 114.524L173.404 108.907C173.953 108.878 174.379 108.418 174.366 107.869L173.79 83.4722C173.777 82.9245 174.201 82.4651 174.748 82.4337L195 81.2698C195.712 81.2288 196.244 81.9154 196.026 82.5947L181.024 129.349C180.898 129.743 180.546 130.021 180.134 130.052L72.5914 138.285C72.0812 138.324 71.6216 137.978 71.5185 137.477L66.7993 114.524Z"
      stroke="white"
      strokeWidth="3.39041"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M200.762 7.78645C199.18 8.12046 197.88 9.36313 197.492 10.9107C197.371 11.3931 197.363 11.4932 197.263 13.5893C197.169 15.5667 197.137 15.9335 196.976 16.8878C196.704 18.5017 196.114 20.318 195.396 21.7538C195.273 21.9997 193.407 25.4284 191.25 29.3733C189.093 33.3182 187.28 36.6637 187.222 36.8077C187.09 37.1321 187.047 37.6566 187.124 37.9897C187.275 38.6379 187.721 39.2151 188.276 39.4785C188.434 39.5536 189.635 39.9307 190.944 40.3164L193.323 41.0177V41.3371C193.324 43.2346 193.556 56.3659 193.594 56.6236C193.872 58.5096 195.36 59.99 197.242 60.2525C197.686 60.3146 234.518 61.4217 235.031 61.3884C235.528 61.3561 236.023 61.2225 236.529 60.9833C237.06 60.7326 237.41 60.4811 237.802 60.0691C238.198 59.652 238.356 59.4209 238.595 58.9126C238.926 58.2072 238.96 57.9877 239.082 55.8498C239.154 54.5922 239.214 53.8581 239.259 53.6871C239.339 53.3859 239.56 53.0212 239.768 52.8462C240.106 52.5616 240.264 52.5177 242.663 52.042C245.577 51.4642 246.278 51.2544 247.666 50.5456C251.12 48.7819 253.638 45.5003 254.417 41.7482C254.645 40.65 254.68 40.137 254.802 36.1253C254.898 32.9905 254.909 32.2244 254.868 31.6687C254.698 29.3449 253.994 27.2831 252.718 25.3665C252.192 24.5776 251.838 24.1496 251.105 23.4159C250.195 22.5061 249.437 21.9242 248.343 21.2949C247.444 20.7784 246.811 20.5334 243.819 19.5454C242.002 18.9455 240.867 18.5482 240.742 18.4686C240.475 18.299 240.268 18.0549 240.115 17.7282C239.991 17.4627 239.984 17.4088 239.77 14.8704C239.528 12.01 239.502 11.852 239.168 11.1564C238.614 10.0059 237.619 9.17089 236.424 8.85291C236.219 8.79832 235.802 8.74032 235.429 8.71433C234.734 8.66589 202.31 7.69755 201.581 7.7034C201.337 7.70539 200.969 7.74275 200.762 7.78645ZM240 26.1C239.749 26.2253 239.555 26.4217 239.403 26.707L239.303 26.8939L239.292 35.5037C239.279 45.1191 239.255 44.3887 239.596 44.776C239.875 45.0929 240.157 45.2221 240.565 45.2193C240.891 45.217 240.945 45.1983 243.708 44.1218C245.255 43.5194 246.644 42.9573 246.796 42.8726C247.878 42.2688 248.644 41.2116 248.91 39.9541C248.988 39.5833 249.218 32.5938 249.186 31.565C249.163 30.836 249.057 30.3931 248.772 29.8255C248.281 28.8499 247.451 28.0853 246.487 27.7203C246.286 27.6442 244.931 27.2229 243.477 26.7841C240.502 25.8867 240.449 25.8762 240 26.1Z"
      fill="#017223"
    />
  </svg>
)

// Іконка стрілки вліво для повернення
export const LeftArrowIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    width="20"
    height="20"
    viewBox="0 0 18 10"
    fill="none"
  >
    <g id="Group 1321317203">
      <path
        d="M17.5001 0.997396V0.997396C12.6716 0.997396 8.75124 4.91856 8.76419 9.74708V9.74708"
        id="Vector 142"
        stroke="#BFBFBF"
        strokeWidth="1.5625"
      />
      <path
        d="M4.56282e-05 0.997397V0.997397C4.82858 0.997397 8.7489 4.91856 8.73595 9.74708V9.74708"
        id="Vector 143"
        stroke="#BFBFBF"
        strokeWidth="1.5625"
      />
    </g>
  </svg>
)

// Компонент для коду країни з прапором та стрілкою
export const PhoneCodeComponent: React.FC<{ className?: string }> = ({ className }) => (
  <div className={className}>
    <div className="flex items-center gap-1">
      <UkraineFlagIcon className="w-[22px] h-[17px] flex-shrink-0" />
      <span className="text-[#0d0d0d] text-[16px] font-normal">+380</span>
      <DownArrowIcon className="w-[10.667px] h-[10.667px] flex-shrink-0" />
    </div>
  </div>
)
